module.exports = __webpack_public_path__ + "assets/img/free_31.77e64ddb.png";